<div class="ds-grid ds-grid--2">
	<!-- Single Open -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Single Open (default)</h3>
			<p class="ds-example__header-subtitle">Opening an item collapses the others</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-accordion [items]="singleOpenItems"></eif-custom-accordion>
		</div>
	</div>

	<!-- Allow Multiple -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Allow Multiple</h3>
			<p class="ds-example__header-subtitle">allowMultiple keeps several items open at once</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-accordion
				[items]="multipleOpenItems"
				[allowMultiple]="true">
			</eif-custom-accordion>
		</div>
	</div>

	<!-- Without Icons -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Without Icons</h3>
			<p class="ds-example__header-subtitle">showIcons set to false hides the chevron</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-accordion
				[items]="noIconsItems"
				[showIcons]="false">
			</eif-custom-accordion>
		</div>
	</div>

	<!-- Custom Icons -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Custom Icons</h3>
			<p class="ds-example__header-subtitle">iconClass and iconClassCollapsed customize the expand indicator</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-accordion
				[items]="customIconItems"
				[iconClass]="'fa-solid fa-minus'"
				[iconClassCollapsed]="'fa-solid fa-plus'">
			</eif-custom-accordion>
		</div>
	</div>

	<!-- No Accent Border -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">No Accent Border</h3>
			<p class="ds-example__header-subtitle">noAccentBorder removes the accent border on every item</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-accordion
				[items]="noAccentItems"
				[noAccentBorder]="true">
			</eif-custom-accordion>
		</div>
	</div>

	<!-- Per-item Accent Border -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Per-item Accent Border</h3>
			<p class="ds-example__header-subtitle">noAccentBorder can also be set on a single item (second item)</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-accordion [items]="mixedAccentItems"></eif-custom-accordion>
		</div>
	</div>

	<!-- Rich HTML Content -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Rich HTML Content</h3>
			<p class="ds-example__header-subtitle">Content is sanitized with DOMPurify (scripts and inline styles are removed)</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-accordion
				[items]="richContentItems"
				[allowMultiple]="true">
			</eif-custom-accordion>
		</div>
	</div>

	<!-- Safe Title -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">HTML Title</h3>
			<p class="ds-example__header-subtitle">safeTitle renders sanitized HTML in the header</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-accordion [items]="safeTitleItems"></eif-custom-accordion>
		</div>
	</div>

	<!-- Single-item Mode -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Single-item Mode</h3>
			<p class="ds-example__header-subtitle">title input with projected Angular content</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-accordion [title]="'View details'">
				<div class="ds-group">
					<eif-custom-button
						[text]="'Projected button'"
						[size]="'small'"
						(action)="lastEvent = 'Projected button clicked'">
					</eif-custom-button>
					<eif-custom-button
						[text]="'Another action'"
						[variant]="'outlined'"
						[size]="'small'"
						(action)="lastEvent = 'Another action clicked'">
					</eif-custom-button>
				</div>
			</eif-custom-accordion>
		</div>
	</div>

	<!-- Single-item Expanded -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Single-item Initially Expanded</h3>
			<p class="ds-example__header-subtitle">isExpanded with the expandedChange output (state: {{ singleExpanded ? 'expanded' : 'collapsed' }})</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-accordion
				[title]="'Initially open'"
				[isExpanded]="true"
				(expandedChange)="onExpandedChange($event)">
				<p>This content was projected into the accordion and is visible on load.</p>
			</eif-custom-accordion>
		</div>
	</div>

	<!-- Events -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Events</h3>
			<p class="ds-example__header-subtitle">Last event: {{ lastEvent }}</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-accordion
				[items]="eventItems"
				[allowMultiple]="true"
				(itemToggle)="onItemToggle($event)">
			</eif-custom-accordion>
		</div>
	</div>

</div>
